import { render, staticRenderFns } from "./GpRadioButton.vue?vue&type=template&id=28630613&scoped=true&"
import script from "./GpRadioButton.vue?vue&type=script&lang=js&"
export * from "./GpRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./GpRadioButton.vue?vue&type=style&index=0&id=28630613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28630613",
  null
  
)

export default component.exports